var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"search-results",attrs:{"data-cy":"search-results"}},[(_setup.isLoading)?_c(_setup.SearchLoader):[_c('h2',{staticClass:"title-with-underline"},[_vm._v(_vm._s(_setup.headlineCopy))]),_c(_setup.GenericContent,{attrs:{"content":_setup.searchResults || [],"limit":_setup.limit}})]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }